import { ProductListingPage } from "@decocms/apps-commerce/types"
import type { JSX } from "react"
import { useMemo } from "react"

const SORT_QUERY_PARAM = 'O'

const useSort = () =>
    useMemo(() => {
        const urlSearchParams = new URLSearchParams(location?.search)
        return urlSearchParams.get(SORT_QUERY_PARAM) ?? ''
    }, [])

// TODO: Replace with "search utils"
const applySort = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const urlSearchParams = new URLSearchParams(location.search)

    urlSearchParams.set(SORT_QUERY_PARAM, e.currentTarget.value)
    location.search = urlSearchParams.toString()
}

export type Props = Pick<ProductListingPage, 'sortOptions'>

// TODO: move this to the loader
export const portugueseMappings = {
    'price:asc': 'Menor Preço',
    'price:desc': 'Maior Preço',
    'orders:desc': 'Mais vendidos',
    'release:desc': 'Data de lançamento',
    'discount:desc': 'Melhor desconto',

    OrderByPriceDESC: 'Maior Preço',
    OrderByPriceASC: 'Menor Preço',
    OrderByTopSaleDESC: 'Mais vendidos',
    OrderByReviewRateDESC: 'Melhor avaliado',
    OrderByNameASC: 'A - Z',
    OrderByNameDESC: 'Z - A',
    OrderByReleaseDateDESC: 'Data de lançamento',
    OrderByBestDiscountDESC: 'Maior desconto',
    OrderByScoreDESC: 'Por relevância',
}

function Sort({ sortOptions }: Props) {
    const sort = useSort()
    const orderSortOptions = [{ value: null, label: 'Ordenar por:' }, ...sortOptions]

    return (
        <select
            id='sort'
            name='sort'
            onChange={applySort}
            className='w-[50%] h-[47px] p-0 lg:w-min lg:h-[36px] px-1 rounded text-base-content cursor-pointer outline-none'
        >
            {orderSortOptions
                .map(({ value, label }) => ({
                    value,
                    label: portugueseMappings[label as keyof typeof portugueseMappings] ?? label,
                }))
                .filter(({ label }) => label)
                .map(({ value, label }) => (
                    <option key={value} value={value!} selected={value === sort}>
                        <span className='text-sm'>{label}</span>
                    </option>
                ))}
        </select>
    )
}

export default Sort
